import {
	addView,
	updateView,
	getViews,
	deleteView,
	getAllViewElements,
	getExtendedViewElementsList,
} from '../../actions/viewActions';

export const SET_ACTIVE_VIEW = 'set_active_view';

export const REQUEST_ADD_VIEW = 'request_add_view';
export const RECEIVE_ADD_VIEW = 'receive_add_view';
export const ADD_VIEW_ERROR = 'add_view_error';

export const REQUEST_UPDATE_VIEW = 'request_update_view';
export const RECEIVE_UPDATE_VIEW = 'receive_update_view';
export const UPDATE_VIEW_ERROR = 'update_view_error';

export const RECEIVE_DELETE_VIEW = 'receive_delete_view';
export const REQUEST_DELETE_VIEW = 'request_delete_view';
export const DELETE_VIEW_ERROR = 'delete_view_error';

export const REQUEST_VIEWS = 'request_views';
export const RECEIVE_VIEWS = 'receive_views';
export const VIEWS_ERROR = 'views_error';

export const REQUEST_ALL_VIEW_ELEMENTS = 'request_all_view_elements';
export const RECEIVE_ALL_VIEW_ELEMENTS = 'receive_all_view_elements';
export const ALL_VIEW_ELEMENTS_ERROR = 'all_view_elements_error';

export const REQUEST_EXTENDED_VIEW_ELEMENTS = 'request_extended_view_elements';
export const RECEIVE_EXTENDED_VIEW_ELEMENTS = 'receive_extended_view_elements';
export const RECEIVE_LIMITED_EXTENDED_VIEW_ELEMENTS = 'receive_limited_extended_view_elements';
export const EXTENDED_VIEW_ELEMENTS_ERROR = 'extended_view_elements_error';

const getAllViewElementsRedux = (modelId, viewId) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_ALL_VIEW_ELEMENTS,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_ALL_VIEW_ELEMENTS,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: ALL_VIEW_ELEMENTS_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call

		const { allElements, layeredElements } = await getAllViewElements(modelId, viewId);
		return onSuccess({ allElements, layeredElements, viewId });
	} catch (error) {
		console.log(error);
		return onError(error);
	}
};

const getExtendedViewElementsListRedux = (modelId, viewId) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_EXTENDED_VIEW_ELEMENTS,
		});
	};

	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_EXTENDED_VIEW_ELEMENTS,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: EXTENDED_VIEW_ELEMENTS_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();

		// load the data little by little
		let index = 0;
		let listLength = 0;
		do {
			const { list, nextIndex } = await getExtendedViewElementsList(modelId, viewId, index);
			listLength = list.length;
			index = nextIndex;

			onSuccess({ extendedViewElementsList: list, viewId });
		} while (listLength > 0);
	} catch (error) {
		console.log(error);
		return onError(error);
	}
};

const getViewsRedux = (modelId) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_VIEWS,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_VIEWS,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: VIEWS_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call

		const views = await getViews(modelId);
		return onSuccess(views);
	} catch (error) {
		console.log(error);
		return onError(error);
	}
};

const setActiveViewRedux = (views, viewId) => (dispatch) => {
	dispatch({
		type: SET_ACTIVE_VIEW,
		payload: { views, viewId },
	});
};

const addViewRedux = (modelId, displayTitle, viewType) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_ADD_VIEW,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_ADD_VIEW,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: ADD_VIEW_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const view = await addView(modelId, displayTitle, viewType);

		return onSuccess(view);
	} catch (error) {
		console.log(error);

		return onError(error);
	}
};
const updateViewRedux = (modelId, viewId, viewData) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_UPDATE_VIEW,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_UPDATE_VIEW,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: UPDATE_VIEW_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const view = await updateView(modelId, viewId, viewData);

		return onSuccess(view);
	} catch (error) {
		console.log(error);

		return onError(error);
	}
};

const deleteViewRedux = (modelId, viewId) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_DELETE_VIEW,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_DELETE_VIEW,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: DELETE_VIEW_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const view = await deleteView(modelId, viewId);

		return onSuccess(view);
	} catch (error) {
		console.log(error);

		return onError(error);
	}
};

export {
	getAllViewElementsRedux,
	setActiveViewRedux,
	addViewRedux,
	updateViewRedux,
	getViewsRedux,
	deleteViewRedux,
	getExtendedViewElementsListRedux,
};
